import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import {
  PLEASE_WAIT, WENT_WRONG, BOOKING_COMPLETE_MSG, BOOKING_ACCEPT_MSG, BOOKING_REJECT_MSG, SHOW_CUSTOMER_MSG, RATE_TYPE_FIXED,
  RATE_TYPE_PER_HOUR, HEADER_ARE_YOU_SURE, RATE_TYPE_PER_MONTH, SUSPEND_STATUS, STATUS_COMPLETE, CANCEL_STATUS, ACTIVE_STATUS,
  STATUS_ACTIVE, STATUS_INACTIVE, STATUS_DELETED, BATCH_STATUS_DELETED, STATUS_SUSPENDED,
  BATCH_STATUS_DELETE, ACCEPTED_ICON, INACTIVE_STATUS, STATUS_DELETE,
  STATUS_ACCEPTED_ICON, COMPLETE_STATUS, STATUS_CANCELLED, STATUS_DECLINED_ICON, STATUS_INPROGRESS

} from 'src/app/constants';
import { CURRENCY } from '../../environments/environment';
@Component({
  selector: 'app-enrol-details',
  templateUrl: './enrol-details.component.html',
  styleUrls: ['./enrol-details.component.scss']
})
export class EnrolDetailsComponent implements OnInit {
  vendorID:string;
  scheduleID:string;
  bookingId:string;
  partyID:string;
  bookingDetails:[];
  courseSchedule:[];
  packageDetails:[];
  packageFeatures:[];
  partyDetails:[];
  reqDetail:[];
  vendorDetails:[];
  paymentDetails:[];
  partyNotes:[];
  currency:string;
  active:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { 

      this.vendorID = this.activatedRoute.snapshot.paramMap.get('vendorID');
      
      this.scheduleID = this.activatedRoute.snapshot.paramMap.get('scheduleID');      
      this.bookingId = this.activatedRoute.snapshot.paramMap.get('bookingId');
      this.partyID = this.activatedRoute.snapshot.paramMap.get('partyID');


    }

  ngOnInit() {

    this.currency = CURRENCY;

    let Enrollmentdata = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID"),
      hostID: localStorage.getItem("hostID"),
      bookingID: this.bookingId,
      partyID: this.partyID,
      vendorID: this.vendorID
    }

    this.apiService.enrollmentDetails(Enrollmentdata).subscribe(async (res: any)=>{     
      this.bookingDetails = res.data.bookingDetailsData.data.bookingDetails;
      this.packageDetails = res.data.bookingDetailsData.data.packageDetails;
      this.courseSchedule =  res.data.bookingDetailsData.data.courseSchedule;
      this.packageFeatures = res.data.bookingDetailsData.data.packageFeatures;
      this.partyDetails = res.data.bookingDetailsData.data.partyDetails;
      this.reqDetail = res.data.bookingDetailsData.data.reqDetail;
      this.vendorDetails = res.data.bookingDetailsData.data.vendorDetails;
      this.paymentDetails =  res.data.bookingDetailsData.data.paymentDetails;
      this.partyNotes = res.data.bookingDetailsData.data.partyNotes;

    },async err => {
     
    })


  }

  getBkNumber(bookingID: string) {
    return 'SC-EN-' + bookingID.toString().padStart(8, '0');
  }

  getstatus(data) {
    switch (data) {
      case 2: return STATUS_INPROGRESS;
      case 3: return COMPLETE_STATUS;
      case 4: return STATUS_DELETED;
      case 5:
        return STATUS_ACCEPTED_ICON;
      case 6:
        return STATUS_DECLINED_ICON;

    }
  }
  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
  }

  getBatchStatus(status) {
    if (status === ACTIVE_STATUS) {
      return STATUS_ACTIVE;
    } else if (status === SUSPEND_STATUS) {
      return STATUS_SUSPENDED;
    } else if (status === STATUS_COMPLETE) {
      return COMPLETE_STATUS;
    } else if (status === CANCEL_STATUS) {
      return STATUS_CANCELLED;
    } else if (status === BATCH_STATUS_DELETE) {
      return BATCH_STATUS_DELETED;
    }
  }

  getCourseStatus(status) {
    if (status === INACTIVE_STATUS) {
      return STATUS_INACTIVE;
    } else if (status === ACTIVE_STATUS) {
      return STATUS_ACTIVE;
    } else if (status === STATUS_DELETE) {
      return STATUS_DELETED;
    }
  }

  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  viewDetails(vendorID,scheduleID,bookingId,partyID){
    
    this.router.navigateByUrl(`enrollment-details/`+ vendorID + `/`+ scheduleID + `/`+ bookingId + `/`+ partyID);
  }
  
  calender(){
    this.router.navigateByUrl(`calender`);
  }
  requirement(){
    
  }
  


}
